import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";

const field = "w-full rounded-lg bg-white px-3 py-2 font-body text-sm border outline-none";
const fieldStyle = { borderColor: "rgba(11,27,61,0.2)", color: "var(--navy)" };

export const BookReviewsAdmin = ({ token }) => {
  const [reviews, setReviews] = useState([]);
  const [quote, setQuote] = useState("");
  const [attribution, setAttribution] = useState("");
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    api.get("/admin/books/reviews", { headers: { Authorization: `Bearer ${token}` } }).then((r) => setReviews(r.data)).catch(() => toast.error("Could not load book reviews."));
  }, [token]);

  const add = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/admin/books/reviews", { quote, attribution }, auth);
      setReviews((rs) => [data, ...rs]);
      setQuote(""); setAttribution("");
      toast.success("Review added to the Swim Books page");
    } catch { toast.error("Could not add review."); }
  };
  const toggle = async (r) => {
    const { data } = await api.patch(`/admin/books/reviews/${r.id}`, { published: !r.published }, auth);
    setReviews((rs) => rs.map((x) => (x.id === r.id ? data : x)));
  };
  const remove = async (r) => {
    if (!window.confirm("Delete this review?")) return;
    await api.delete(`/admin/books/reviews/${r.id}`, auth);
    setReviews((rs) => rs.filter((x) => x.id !== r.id));
  };

  return (
    <section className="mt-20" data-testid="admin-book-reviews">
      <p className="overline mb-3" style={{ color: "var(--gold)" }}>Personalized Swim Books</p>
      <h2 className="font-display text-3xl md:text-4xl mb-2" style={{ color: "var(--navy)" }}>Book reviews</h2>
      <p className="font-body font-light mb-8" style={{ color: "var(--muted)" }}>Add real quotes from families who received their book. The section appears on Swim Books once at least one review is shown.</p>
      <form onSubmit={add} className="grid md:grid-cols-[2fr_1fr_auto] gap-3 items-end mb-6" data-testid="book-review-form">
        <textarea required minLength={5} rows={2} placeholder="Parent's quote…" value={quote} onChange={(e) => setQuote(e.target.value)} className={field} style={fieldStyle} data-testid="book-review-quote" />
        <input placeholder="A Mimi & Me parent" value={attribution} onChange={(e) => setAttribution(e.target.value)} className={field} style={fieldStyle} data-testid="book-review-attribution" />
        <button type="submit" className="px-5 py-2.5 rounded-full text-xs font-body text-white" style={{ backgroundColor: "var(--navy)" }} data-testid="book-review-add">Add review</button>
      </form>
      <div className="space-y-3">
        {reviews.map((r) => (
          <div key={r.id} className="flex items-start gap-4 p-5 rounded-2xl bg-white border" style={{ borderColor: "rgba(212,175,55,0.3)" }} data-testid={`admin-book-review-${r.id}`}>
            <div className="flex-1 font-body text-sm" style={{ color: "var(--navy)" }}>“{r.quote}” <span style={{ color: "var(--muted)" }}>— {r.attribution}</span></div>
            <label className="flex items-center gap-2 font-body text-xs whitespace-nowrap cursor-pointer" style={{ color: "var(--navy)" }}>
              <input type="checkbox" checked={r.published} onChange={() => toggle(r)} className="accent-[var(--navy)]" data-testid={`book-review-published-${r.id}`} /> Show on site
            </label>
            <button onClick={() => remove(r)} aria-label="Delete review" style={{ color: "#B42318" }} data-testid={`book-review-delete-${r.id}`}><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
    </section>
  );
};
